/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  InviteUserByOrganizationnMutationRequest,
  InviteUserByOrganizationnMutationResponse,
  InviteUserByOrganizationnPathParams,
} from "../types/InviteUserByOrganizationn.ts"

export const inviteUserByOrganizationnMutationKey = () =>
  [{ url: "/v1/user/invite-users-by-organization/:organizationId" }] as const

export type InviteUserByOrganizationnMutationKey = ReturnType<
  typeof inviteUserByOrganizationnMutationKey
>

/**
 * @summary Invite users to organization
 * {@link /v1/user/invite-users-by-organization/:organizationId}
 */
export async function inviteUserByOrganizationn(
  organizationId: InviteUserByOrganizationnPathParams["organizationId"],
  data: InviteUserByOrganizationnMutationRequest,
  config: Partial<RequestConfig<InviteUserByOrganizationnMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    InviteUserByOrganizationnMutationResponse,
    ResponseErrorConfig<Error>,
    InviteUserByOrganizationnMutationRequest
  >({
    method: "POST",
    url: `/v1/user/invite-users-by-organization/${organizationId}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function inviteUserByOrganizationnMutationOptions(
  config: Partial<RequestConfig<InviteUserByOrganizationnMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = inviteUserByOrganizationnMutationKey()
  return mutationOptions<
    ResponseConfig<InviteUserByOrganizationnMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: InviteUserByOrganizationnPathParams["organizationId"]
      data: InviteUserByOrganizationnMutationRequest
    },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ organizationId, data }) => {
      return inviteUserByOrganizationn(organizationId, data, config)
    },
  })
}

/**
 * @summary Invite users to organization
 * {@link /v1/user/invite-users-by-organization/:organizationId}
 */
export function useInviteUserByOrganizationn<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<InviteUserByOrganizationnMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        organizationId: InviteUserByOrganizationnPathParams["organizationId"]
        data: InviteUserByOrganizationnMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<InviteUserByOrganizationnMutationRequest>
    > & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? inviteUserByOrganizationnMutationKey()

  const baseOptions = inviteUserByOrganizationnMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<InviteUserByOrganizationnMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: InviteUserByOrganizationnPathParams["organizationId"]
      data: InviteUserByOrganizationnMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<InviteUserByOrganizationnMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: InviteUserByOrganizationnPathParams["organizationId"]
      data: InviteUserByOrganizationnMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<InviteUserByOrganizationnMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      organizationId: InviteUserByOrganizationnPathParams["organizationId"]
      data: InviteUserByOrganizationnMutationRequest
    },
    TContext
  >
}
